///////////////////////////////////////////////////////////////////////////////////////////////////
//
//  Namespaces
//
///////////////////////////////////////////////////////////////////////////////////////////////////
abcsetup.replenishment_request = abcsetup.replenishment_request || {};
abcsetup.replenishment_request.show = abcsetup.replenishment_request.show || {};


///////////////////////////////////////////////////////////////////////////////////////////////////
//
//  Methods
//
///////////////////////////////////////////////////////////////////////////////////////////////////
abcsetup.replenishment_request.show = {

    init: function() {
        if (abcsetup.userRole.class == 'ro_manager') {
            
            $(document).on('click', '.re-send-supplier-input-js', function() {
                $('.re-send-supplier-input-js:checked').length > 0
                    ? $('#resend-supplier-btn-js').removeClass('d-none')
                    : $('#resend-supplier-btn-js').addClass('d-none');
            });

            $('#resend-supplier-btn-js').on('click', function() {
                abcsetup.alerts.confirm(
                    'Resend to Supplier',
                    'Would you like to resend the selected items to the supplier to allow them to update their submitted item comments? This action will not interupt this cases\' workflow.',
                    function(resp) {
                        if (resp) {
                            abcsetup.blockUI(true);

                            axios.post('/api/replenishment_operations/resend_supplier', {
                                replenishment_request_id: $('#replenishment_request_id').val(),
                                replenishment_item_ids: $('.re-send-supplier-input-js:checked').map((index, element) => element.value).get()
                            })
                            .then(response => {
                                const data = response.data;

                                if (data.success) {
                                    abcsetup.unblockUI();
                                    abcsetup.alerts.show('Success', data.message);

                                    $('#resend-supplier-btn-js').addClass('d-none');
                                    $('.re-send-supplier-input-js:checked').attr('disabled', true);
                                }
                            })
                            .catch(error => {
                                abcsetup.unblockUI();
                                console.error(error);
                                abcsetup.alerts.show('Error', 'An error occurred while resending the supplier request. Please try again.');
                            });
                        }
                    }
                )
            });
        }
    },
}
